import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {Button, Box, Grid, Typography, Container} from '@material-ui/core';
import {Anchor} from 'components/icons/icons';
import {AppCtx} from 'context/AppContext';
import {useFlags} from 'hooks';
import useBrowserTitle from 'hooks/useBrowserTitle';
import {GoBackButton} from './AddSeaservice';

const useStyles = makeStyles(theme => ({
    button: {
        backgroundColor: `${theme.palette.primary.light2}`,
        border: 0,
        borderRadius: 3,
        height: 70,
        width: 70,
        margin: '2px 30px',
        padding: '10px',
    },
}));

const iconProps = {
    height: 50,
    width: 50,
};

const FormTypeOption = ({
    formName,
    formPath,
    formDescription,
    icon: Icon,
    disabled,
}) => {
    const classes = useStyles();
    const {setInForm} = useContext(AppCtx);

    // This is pre-form so set form context
    useEffect(() => {
        setInForm(true);
        return () => {
            setInForm(false);
        };
    }, [setInForm]);

    return (
        <>
            <Button
                disabled={disabled}
                variant='contained'
                className={classes.button}
                to={formPath}
                component={Link}
            >
                <Icon {...iconProps} />
            </Button>

            <Typography align='center'>{formName}</Typography>

            <Typography align='center'>{formDescription}</Typography>
        </>
    );
};

const AddUniformedService = () => {
    useBrowserTitle(`| Add Uniformed Service`);
    const {noaatoss_form_active, uscg_forms_active, armytoss_form_active} =
        useFlags();
    return (
        <Container maxWidth='xs'>
            <Box textAlign='center'>
                <Grid
                    container
                    spacing={2}
                    direction='column'
                    justifyContent='flex-start'
                    alignItems='center'
                >
                    <Grid item />
                    <Grid item>
                        <Typography variant='h6' align='center'>
                            Ok! First Question: <p></p>
                            What branch of the Uniformed Service did you obtain
                            your sea time with?
                        </Typography>
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='NOAA'
                            icon={Anchor}
                            key='noaatoss'
                            formPath={'/forms/noaatoss'}
                            disabled={!noaatoss_form_active}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='USCG'
                            icon={Anchor}
                            key='uscg'
                            formPath={'/uniformedservice/uscg'}
                            disabled={!uscg_forms_active}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='Army'
                            icon={Anchor}
                            key='army'
                            formPath={'/forms/armytoss'}
                            disabled={!armytoss_form_active}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='Navy'
                            icon={Anchor}
                            key='navy'
                            //formPath={'/forms/navy'}
                            disabled
                        />
                    </Grid>
                    <Grid item>
                        <GoBackButton />
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default AddUniformedService;
export {FormTypeOption};
